import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { connect } from 'react-redux'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { ReactComponent as Insta } from '../../images/insta.svg'
import { ReactComponent as Linkedin } from '../../images/linkedin.svg'
import { ReactComponent as Youtube } from '../../images/youtube.svg'
import './footer.css'
import theme from '../../config/theme'
class Footer extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            footerText: process.env.REACT_APP_FOOTER_TEXT, 
            whitelabel: process.env.REACT_APP_NAME,
            instagram: process.env.REACT_APP_INSTAGRAM,
            linkedin: process.env.REACT_APP_LINKEDIN,
            youtube: process.env.REACT_APP_YOUTUBE,
            email: process.env.REACT_APP_EMAIL
        }
    }
    render() {
        const { logged, userLogged, background } = this.props
        const { footerText, whitelabel, instagram, linkedin, youtube, email } = this.state
        return(
            <footer 
                className="insideSec" 
                style={{
                    backgroundColor: background ? theme.colors.secondary : 'transparent',
                    fontFamily: theme.typography.fontFamily.primary
                }}
            >
                <Container>
                    <Row>
                        <Col md={12} className="mb-5">
                            <hr />
                        </Col>
                        <Col md={2} className="mb-5">
                            <img alt="Ícone branco" src={theme.logos.icon} />
                        </Col>
                        <Col md={10} className="mb-5">
                            <Row>
                                <Col md={3}></Col>
                                <Col md={3} className="col-6">
                                    <label className="text-white footerLabel">Páginas</label><br />
                                    <ul className="footerList">
                                        <li><a href="https://up365capital.com.br" className="text-white">Inicio</a></li>
                                        <li><a href="https://up365capital.com.br/#quem-somos" className="text-white">Sobre</a></li>
                                        <li><a href="https://wa.me/5512992263753?text=Olá!%20Gostaria%20de%20solicitar%20atendimento%20!" className="text-white">Suporte</a></li>
                                    </ul>   
                                </Col>
                                <Col md={3} className="col-6">
                                    <label className="text-white footerLabel">Siga o {whitelabel}</label><br />
                                    <div className="d-flex flex-column iconsFooterWrapper">
                                        <a rel="noopener noreferrer" href="https://www.instagram.com/up365.capital/"target="_blank">
                                            <div className="d-flex align-items-center">
                                                <Insta/>
                                                <label className="text-white mb-0 mt-1" role='button'>Instagram</label>
                                            </div>
                                        </a>
                                        {/* <a rel="noopener noreferrer" href={linkedin} target="_blank">
                                            <div className="d-flex align-items-center">
                                                <Linkedin />
                                                <label className="text-white mb-0 mt-1" role='button'>LinkedIn</label>
                                            </div>
                                        </a>
                                        <a rel="noopener noreferrer" href={youtube} target="_blank">
                                            <div className="d-flex align-items-center">
                                                <Youtube />
                                                <label className="text-white mb-0 mt-1" role='button'>Youtube</label>
                                            </div>
                                        </a> */}
                                    </div>
                                </Col>
                                <Col md={3} className="col-6">
                                    <label className="text-white footerLabel">Contato</label><br />
                                    <ul className="footerList">
                                        <li className="text-white"><label>Contato@up365capital.com.br</label></li>
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={12} className="d-flex justify-content-center mt-5">
                            <label 
                                className="labelLast text-white mt-3" 
                                dangerouslySetInnerHTML={{ __html: footerText }}
                                style={{
                                    fontSize: theme.typography.fontSize.medium,
                                    fontFamily: theme.typography.fontFamily.primary
                                }}
                            />
                        </Col>
                    </Row>
                </Container>
            </footer>
        )
    }    
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
